import React from 'react';

import '../Pages.scss';

function Loading() {
  return (
    <div className='gigacore-theme'>
      <div className='gigacore-container'>
        <h1 className='gigacore-title'>GigaCore</h1>
        <p>
          Loading<span className='loading-dot'>.</span>
          <span className='loading-dot'>.</span>
          <span className='loading-dot'>.</span>
        </p>
      </div>
    </div>
  );
}

export default Loading;
